// Core login system modules
import {
    Login,
    ForgotPassword,
    ResetPassword,
    Login2ndFactor,
    FrontendLogin_Modal
} from './js/frontend-login';

// Two-factor authentication redirect handler
import UltimateLogin2FARedirect from './js/wp-2fa-redirect';

// Global utility modules
import reCAPTCHAs from './js/recaptcha';
import Modals from './js/dialog';

// Import main stylesheet
import './scss/main.scss';

// Do on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // reCAPTCHA (global module)
    new reCAPTCHAs();

    // Modals (global module)
    new Modals();

    // Frontend Login
    new Login();
    new ForgotPassword();
    new ResetPassword();
    new Login2ndFactor();

    // Make 2FA redirect handler globally available
    window.UltimateLogin2FARedirect = UltimateLogin2FARedirect;

    // Exceptions for the login form when
    // it's used on a modal
    new FrontendLogin_Modal();
});
